export default [
  {
    path: '/brand',
    name: 'brand',
    component: () => import('@/views/brand/BrandOverview.vue'),
    meta: {
      pageTitle: 'Brand',
      breadcrumb: [
        {
          text: 'Brand',
          active: true,
        },
      ],
    },
  },
  {
    path: '/brand/vision',
    name: 'brand-vision',
    component: () => import('@/views/brand/Vision.vue'),
    meta: {
      pageTitle: 'Vision',
      breadcrumb: [
        {
          text: 'Brand',
        },
        {
          text: 'Vision',
          active: true,
        },
      ],
    },
  },
  {
    path: '/brand/mission',
    name: 'brand-mission',
    component: () => import('@/views/brand/Mission.vue'),
    meta: {
      pageTitle: 'Mission',
      breadcrumb: [
        {
          text: 'Brand',
        },
        {
          text: 'Mission',
          active: true,
        },
      ],
    },
  },
  {
    path: '/brand/values',
    name: 'brand-values',
    component: () => import('@/views/brand/Values.vue'),
    meta: {
      pageTitle: 'Values',
      breadcrumb: [
        {
          text: 'Brand',
        },
        {
          text: 'Values',
          active: true,
        },
      ],
    },
  },
]
